import SmartToyIcon from '@mui/icons-material/SmartToy';
import TerminalIcon from '@mui/icons-material/Terminal';
import { Box, Chip, colors, Stack, styled } from '@mui/material';
import { Button } from '~/components/Button';
import {
  ContentContainer,
  Kicker,
  SectionH2,
} from '~/components/HomepageV3/styles';
import { FakeTerminal } from '~/scenes/mcp/FakeTerminal';

const supportedClients = [
  { name: 'Claude Desktop', Icon: SmartToyIcon },
  { name: 'ChatGPT', Icon: SmartToyIcon },
  { name: 'Cursor', Icon: SmartToyIcon },
  { name: 'Any MCP Client', Icon: TerminalIcon },
];

export const McpTeaserSection = () => (
  <McpSectionRoot>
    <ContentContainer sx={{ py: 12 }}>
      <McpGrid>
        <div>
          <Kicker>AI-native access</Kicker>
          <SectionH2 sx={{ mt: 1.5, mb: 1.5 }}>
            Use NerdyData within your AI assistant.
          </SectionH2>
          <McpLede>
            Ask Claude, Cursor, or ChatGPT to find leads, look up domain tech
            stacks, and export lists — all in natural language.
          </McpLede>
          <Stack direction="row" spacing={1.5} flexWrap="wrap" sx={{ mb: 3 }}>
            <Button href="/mcp" variant="contained">
              Learn More
            </Button>
            <Button href="/api" variant="outlined">
              API Docs
            </Button>
          </Stack>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {supportedClients.map(({ name, Icon }) => {
              return (
                <Chip
                  key={name}
                  label={name}
                  variant="outlined"
                  size="small"
                  icon={<Icon fontSize="small" />}
                />
              );
            })}
          </Box>
        </div>
        <FakeTerminal />
      </McpGrid>
    </ContentContainer>
  </McpSectionRoot>
);

const McpSectionRoot = styled(Box)`
  background: ${colors.grey[50]};
  border-top: 1px solid ${colors.grey[200]};
  border-bottom: 1px solid ${colors.grey[200]};
`;

const McpGrid = styled(Box)`
  display: grid;
  grid-template-columns: 1fr 1.1fr;
  gap: 56px;
  align-items: center;

  @media (max-width: 880px) {
    grid-template-columns: 1fr;
    gap: 32px;
  }
`;

const McpLede = styled('p')`
  font-size: 17px;
  line-height: 1.55;
  color: ${colors.grey[600]};
  margin: 12px 0 24px;
  max-width: 48ch;
`;
